// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sDr7SSmjGRizodrJP0vK{background-color:#ebf7ff;padding:20px 30px;margin-bottom:25px}@media(min-width: 1024px){.sDr7SSmjGRizodrJP0vK{margin-bottom:50px;padding:20px 25px}}.zcI_lVS4bme9VKx7fafT{margin-bottom:18px;max-width:50em}@media(min-width: 1024px){.zcI_lVS4bme9VKx7fafT{margin-bottom:25px}}.pBbYZtE6DuedBkcgHkfv{display:grid;grid-template-columns:1fr 1fr;gap:16px}@media(max-width: 767px){.pBbYZtE6DuedBkcgHkfv{grid-template-columns:1fr;grid-gap:12px}}.Vr1unykk7rJzwWACbfYX{display:flex;line-height:1.2}.Vr1unykk7rJzwWACbfYX svg{width:24px;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "sDr7SSmjGRizodrJP0vK",
	"title": "zcI_lVS4bme9VKx7fafT",
	"dataContainer": "pBbYZtE6DuedBkcgHkfv",
	"info": "Vr1unykk7rJzwWACbfYX"
};
export default ___CSS_LOADER_EXPORT___;
